import { useEffect, useState } from "react";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { dashboardMechanicTop7 } from "../../config/apiSPA.js";
import { Link } from "react-router-dom";

function Top7Mechanics() {
  const [top7, setTop7] = useState();
  useEffect(() => {
    dashboardMechanicTop7().then((res) => setTop7(res));
  }, []);
  return (
    <>
      <div className="row mt-5">
        {top7
          ? top7.map((value, index) => (
              <div className="col-xl-6" key={index}>
                <Card className="mb-3">
                  <CardBody>
                    <div className="d-flex fw-bold small mb-3">
                      <span className="flex-grow-1">{value.judul}</span>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-striped table-borderless mb-2px small text-nowrap">
                        <tbody>
                          {value.data
                            ? value.data.map((dat, i) => (
                                <tr key={i}>
                                  <td>
                                    <span className="d-flex align-items-center">
                                      <i className="bi bi-circle-fill fs-6px me-2 text-inverse text-opacity-30"></i>
                                      <Link to={"/manpower/detail/" + dat.id}>{dat.nrp}</Link>
                                    </span>
                                  </td>
                                  <td>{dat.nama}</td>
                                  <td>{dat.parameter}</td>
                                  <td>
                                    <small>{dat.subSec}</small>
                                  </td>
                                </tr>
                              ))
                            : ""}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </div>
            ))
          : "no Data"}
      </div>
      {/* ----------------End Top7 Tab------------------------------------------------------------------ */}
    </>
  );
}
export default Top7Mechanics;
